import apiClient from "./client";
import type { IdParam } from "../types/common";
import type {
  MailCreateUpdatePayload,
  MailGetResponse,
  MailMutationResponse,
} from "../types/mail";

export const getMail = async (mailId: IdParam): Promise<MailGetResponse> => {
  const { data } = await apiClient.get<MailGetResponse>(`/mail/${mailId}`);
  return data;
};

export const createMail = async (
  data: MailCreateUpdatePayload
): Promise<MailMutationResponse> => {
  const { data: response } = await apiClient.post<MailMutationResponse>(
    "/mail",
    data
  );
  return response;
};

export const updateMail = async (
  data: MailCreateUpdatePayload
): Promise<MailMutationResponse> => {
  const { data: response } = await apiClient.put<MailMutationResponse>(
    "/mail",
    data
  );
  return response;
};
